import useTenantConfigData from 'src/careflow/ph-core/multi-tenant/tenant/hook/useTenantConfigData';
import TaskModal from './TaskModal';
import TaskModalNoWizard from './TaskModalNoWizard';

type TaskVariant = 'wizard' | 'no-wizard';

const taskModalRegistry: Record<TaskVariant, React.ComponentType<any>> = {
  wizard: TaskModal,
  'no-wizard': TaskModalNoWizard,
};

export const TaskModalResolver = (props: any) => {
  const { componentsData } = useTenantConfigData();
  const { taskVariantComponent } = componentsData?.task ?? {};

  const Component = taskModalRegistry[taskVariantComponent as TaskVariant] ?? TaskModal;

  return <Component {...props} />;
};
